import api from './index';
//
let exports = {};

//
exports.getHandoverManfPageList = function (postData, callback) {
    api.post('/retailer/handover/manf/list/get')
        .data(postData)
        .done(callback)
        .go();
};
// 获取-交接单信息
exports.getHandoverManfInfo = function (postData, callback) {
    api.post('/retailer/handover/manf/info/get')
        .data(postData)
        .done(callback)
        .go();
};
// 获取-交接单详情
exports.getHandoverManfDetail = function (postData, callback) {
    api.post('/retailer/handover/manf/detail/get')
        .data(postData)
        .done(callback)
        .go();
};

// 更新交接单
exports.updateRetailerHandover = function (postData, callback) {
    api.post('/retailer/handover/manf/update/do')
        .data(postData)
        .done(callback)
        .go();
};

// 确认交接单
exports.doAuditRetailerHandoverManf = function (postData, callback) {
    api.post('/retailer/handover/manf/audit/do')
        .data(postData)
        .done(callback)
        .go();
};

// 交接单：批量交接完成
exports.doBatchHandoverFinished = function (postData, callback) {
    api.post('/retailer/handover/manf/finished/batch/do')
        .data(postData)
        .done(callback)
        .go();
};

// 开始交接单
exports.updateHandoverStart = function (postData, callback) {
    api.post('/retailer/handover/manf/update/for/start/do')
        .data(postData)
        .done(callback)
        .go();
};

// 删除交接单
exports.deleteHandoverManf = function (postData, callback) {
    api.post('/retailer/handover/manf/delete/do')
        .data(postData)
        .done(callback)
        .go();
};
// 撤回交接单
exports.resetStateHandoverManf = function (postData, callback) {
    api.post('/retailer/handover/manf/reset/state/do')
        .data(postData)
        .done(callback)
        .go();
};

// 获取零售商交接单项列表
exports.getRetailerHandoverItemList = function (postData, callback) {
    api.get('/retailer/handover/item/list/get')
        .params(postData)
        .done(callback)
        .go();
};

// 交接成功
exports.updateRetailerHandoverItemState = function (postData, callback) {
    api.post('/retailer/handover/item/state/update/do')
        .data(postData)
        .done(callback)
        .go();
};

// 根据交接人id 生成交接单项列表
exports.getRetailerHandoverItemListByStaffId = function (postData, callback) {
    api.post('/retailer/handover/manf/item/list/get')
        .data(postData)
        .done(callback)
        .go();
};

// 获取交接明细项列表
exports.getRetailerHandoverDetailItemList = function (postData, callback) {
    api.post('/retailer/handover/detail/item/list/get')
        .data(postData)
        .done(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/handover.js
// module id = 135
// module chunks = 0